import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  active: 0,
  loading: false,
  error: null,
};

const ActiveUser = createSlice({
  name: "activeUsers",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    UsersOnline: (state, action) => {
      state.active = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.active = null;
    },
  },
});

// Actions
export const { requestStart, UsersOnline, requestFailure } = ActiveUser.actions;

export default ActiveUser.reducer;
